/*       */
import Immutable from 'app/utils/immutable/Immutable';

import {
    LOAD_MESSAGE_READ_RECEIPTS_STARTED,
    LOAD_MESSAGE_READ_RECEIPTS,
} from 'store/actions/chat/chatActions';
import { get } from 'app/utils/lo/lo';

const initialState = {};

export default (state = initialState, action) => {
    const { type, meta, error, payload } = action;
    switch (type) {
        case LOAD_MESSAGE_READ_RECEIPTS_STARTED: {
            const messageId = get(meta, 'messageId');
            if (!messageId) return state;
            return Immutable({
                ...state,
                [messageId]: { isLoading: true, data: [], error: null },
            });
        }
        case LOAD_MESSAGE_READ_RECEIPTS: {
            const messageId = get(payload, 'messageId');
            if (!messageId) return state;
            if (error) {
                return Immutable({
                    ...state,
                    [messageId]: {
                        isLoading: false,
                        data: [],
                        error: get(meta, 'errorMessage') || 'Failed to load receipts.',
                    },
                });
            }
            return Immutable({
                ...state,
                [messageId]: {
                    isLoading: false,
                    data: get(payload, 'receipts') || [],
                    error: null,
                },
            });
        }
        default:
            return state;
    }
};
